import { languageHelper } from "../../../config/helperFunctions";
import React, { useState } from "react";

function Waiter() {
  const [checkAll, setCheckAll] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);

  const handleCheckAllChange = (e) => {
    const isChecked = e.target.checked;
    setCheckAll(isChecked);
    setCheckedItems(isChecked ? ["item1", "item2", "item3"] : []);
  };

  const handleCheckboxChange = (value) => {
    const updatedCheckedItems = checkedItems.includes(value)
      ? checkedItems.filter((item) => item !== value)
      : [...checkedItems, value];

    setCheckedItems(updatedCheckedItems);
    setCheckAll(updatedCheckedItems.length === 3); // Adjust the length based on the number of items
  };

  const [rows, setRows] = useState([
    { id: 1, content: "Item 1" },
    // { id: 2, content: "Item 2" },
    // { id: 3, content: "Item 3" },
    // Add more rows as needed
  ]);

  const deleteRow = (id) => {
    setRows((prevRows) => prevRows.filter((row) => row.id !== id));
  };

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">

        <div className="py-3" >
          <h1 className="text-[#7B20C7] text-2xl">{languageHelper("Waiter")}</h1>
        </div>

        <div className="flex justify-center">
          <button
            className="flex mb-10  bg-[#7B20C7]  text-white text-sm px-3 py-1 rounded  "
            type="submit"
          >
            {languageHelper("Notification")}
          </button>
        </div>

        <div className="text-[#7B20C7] text-2xl pt-5 m-auto">
          <p>{languageHelper("Notification List")}</p>

          <hr className="my-3 min-h-0.5 bg-[#7B20C7]" />
        </div>

        <div className="max-w-xl  m-auto justify-center items-center">
          <input
            id="checkAll"
            className="mr-3"
            type="checkbox"
            checked={checkAll}
            onChange={handleCheckAllChange}
          />
          {languageHelper("Select All")}
          <hr className="my-2 h-px border-t-0 bg-transparent bg-gradient-to-r from-transparent via-neutral-500 to-transparent opacity-25 dark:opacity-100" />
          <div className="flex">
            <div className="flex justify-end">
              <table>
                <tbody>
                  {rows.map((row) => (
                    <tr key={row.id}>
                      <td className="text-sm">
                        <input
                          type="checkbox"
                          className="mr-3"
                          checked={checkedItems.includes("item1")}
                          onChange={() => handleCheckboxChange("item1")}
                          id="pe-5"
                        />
                        Item: deal 2 is ready to serve, Table: None, Customer:
                        Walk-in Customer, Order: A 000351
                      </td>
                      <td>
                        <button className="p-2 rounded-md bg-[#7B20C7] text-sm text-white" onClick={() => deleteRow(row.id)}>{languageHelper("Collect")}</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <hr className="my-2 h-px border-t-0 bg-transparent bg-gradient-to-r from-transparent via-neutral-500 to-transparent opacity-25 dark:opacity-100" />
          <div className="flex">
            <div className="flex justify-end">
              <table>
                <tbody>
                  {rows.map((row) => (
                    <tr key={row.id}>
                      <td className="text-sm">
                        <input
                          type="checkbox"
                          className="chk mr-3"
                          checked={checkedItems.includes("item2")}
                          onChange={() => handleCheckboxChange("item2")}
                          id="pe-5"
                        />
                        Item: deal 2 is ready to serve, Table: None, Customer:
                        Walk-in Customer, Order: A 000352
                      </td>
                      <td>
                        <button className="p-2 rounded-md bg-[#7B20C7] text-sm text-white" >{languageHelper("Collect")}</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <hr className="my-2 h-px border-t-0 bg-transparent bg-gradient-to-r from-transparent via-neutral-500 to-transparent opacity-25 dark:opacity-100" />
          <div className="flex">
            <div className="flex justify-end">
              <table>
                <tbody>
                  {rows.map((row) => (
                    <tr key={row.id}>
                      <td className="text-sm">
                        <input
                          type="checkbox"
                          className="chk mr-3"
                          checked={checkedItems.includes("item2")}
                          onChange={() => handleCheckboxChange("item2")}
                          id="pe-5"
                        />
                        Item: deal 2 is ready to serve, Table: None, Customer:
                        Walk-in Customer, Order: A 000352
                      </td>
                      <td>
                        <button className="p-2 rounded-md bg-[#7B20C7] text-sm text-white" onClick={() => deleteRow(row.id)}>{languageHelper("Collect")}</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <hr className="my-2 h-px border-t-0 bg-transparent bg-gradient-to-r from-transparent via-neutral-500 to-transparent opacity-25 dark:opacity-100" />

          <div className="flex justify-end">
            <button
              className="flex items-center justify-center bg-[#CFCFCF] object-center justify-self-start px-5 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
              type="submit"
              onClick={() => deleteRow}
            >
              {languageHelper("Remove")}
            </button>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Waiter;
